import React, { ReactNode } from 'react';
import packageJson from '../../../../../package.json';
const Banner: React.FC<{ children: ReactNode }> = ({ children }: { children: ReactNode}) => {
	return (
		<div className="px-3 lg:px-0 w-full h-24 lg:h-40 bg-gradient-to-r from-brand-secondary to-brand flex flex-col items-center justify-center">
			<div
				id="banner-title"
				className="text-font-contrast font-semibold tracking-wide text-center text-2xl lg:text-3xl flex flex-col gap-3 lg:gap-8 max-w-6xl"
				data-coreversion={packageJson.version.toString()}>
				{children}
			</div>
		</div>
	);
};

export default Banner;
